import React from 'react';

interface ClickPortalResultRowsLoaderProps {
  isLoading: boolean;
  cardCount?: number;
}

export default function ClickPortalResultRowsLoader({
  isLoading,
  cardCount = 4,
}: ClickPortalResultRowsLoaderProps): React.JSX.Element | null {
  if (!isLoading) return null;

  return (
    <div
      className="clickPortalResultRowsLoader"
      data-testid="clickPortalResultRowsLoader"
    >
      <div className="clickPortalResultRowsLoader__title" />
      <div className="clickPortalResultRowsLoader__subtitle" />
      <ul className="clickPortalResultRowsLoader__cards">
        {Array.from({ length: cardCount }).map((__, index) => (
          <li
            key={`loader-card-${index + 1}`}
            className="clickPortalResultRowsLoader__card"
            data-testid="clickPortalResultRowsLoaderCard"
          >
            <div className="clickPortalResultRowsLoader__cardImage" />
            <div className="clickPortalResultRowsLoader__cardContent">
              <div className="clickPortalResultRowsLoader__cardTitle" />
              <div className="clickPortalResultRowsLoader__cardSubtitle" />
              <div className="clickPortalResultRowsLoader__cardProgram" />
            </div>
            <div className="clickPortalResultRowsLoader__action" />
          </li>
        ))}
      </ul>
    </div>
  );
}
